import snakeCaseKeys from 'snakecase-keys';

import { getRequest } from '@helpers/api';

import {
  type DownloadPLSaftResponse,
  type DownloadOfficialXmlResponse,
  type DownloadOfficialXmlPayload,
} from './types';

/** Retrives download URI for Polish SAFT */
export const downloadPLSaft = (standardTemplateId: string): Promise<DownloadPLSaftResponse> =>
  getRequest(`vFile/saftExcelDownload/${standardTemplateId}`);

/** Retrieves download URI for XML document */
export const downloadOfficialXML = (
  standardTemplateId: string,
  payload: DownloadOfficialXmlPayload
): Promise<DownloadOfficialXmlResponse> =>
  getRequest(`vFile/automatedXmlFiling/${standardTemplateId}/`, snakeCaseKeys(payload));
